
import { Component, Vue, Prop } from 'vue-property-decorator';
import Swiper from 'swiper';
import { getOldInterface } from '@/apis/index';
import { STAT, URLVER } from '@/config/config';
@Component
export default class Analyst extends Vue {
  swiper: any = null;
  isSub = 0;
  @Prop() private list!: Array<object>;
  formatName(name: string) {
    return name.substr(0, 1);
  }
  followInstead(item: any, status: number) {
    this.isSub = 0;
    if (status === 1) {
      this.isSub = 2;
      window.hxmPageStat(`${STAT.noFollow}.guanzhu`, URLVER);
    } else {
      this.isSub = 1;
      window.hxmPageStat(`${STAT.follow}.jianguanzhu`, URLVER);
    }
    getOldInterface({
      act: 'follow',
      con: 'user',
      type: 3,
      status,
      followId: item.authorId,
    })
      .then(res => {
        if (res.statusCode === 0) {
          this.$set(item, 'followType', !item.followType);
          this.$set(this.$followAuthorList, item.authorId, this.isSub);
        }
        if (res.statusCode === 300) {
          this.$toast('用户未登录');
        }
      })
      .catch(() => {
        this.$toast('服务器开小差了');
      });
  }
  follow(item: any, status: number) {
    if (window.getAccount()) {
      this.followInstead(item, status);
    } else {
      window.location.href = 'http://eqhexin/changeUser';
    }
  }
  mounted() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
    this.swiper = new Swiper('#hotAnalyst', {
      slidesPerView: 'auto',
      normalizeSlideIndex: false,
      observer: true,
    });
  }
}
